/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} IndoorInputs */

const en_indoor = /** @type {(inputs: IndoorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indoor`)
};

const th_indoor = /** @type {(inputs: IndoorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ในร่ม`)
};

const ja_indoor = /** @type {(inputs: IndoorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`室内`)
};

const fr_indoor = /** @type {(inputs: IndoorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intérieur`)
};

const es_indoor = /** @type {(inputs: IndoorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interior`)
};

const ru_indoor = /** @type {(inputs: IndoorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В помещении`)
};

const zh_indoor = /** @type {(inputs: IndoorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`室内`)
};

const vi_indoor = /** @type {(inputs: IndoorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trong nhà`)
};

/**
* | output |
* | --- |
* | "Indoor" |
*
* @param {IndoorInputs} inputs
* @param {{ locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }} options
* @returns {LocalizedString}
*/
export const indoor = /** @type {((inputs?: IndoorInputs, options?: { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<IndoorInputs, { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_indoor(inputs)
	if (locale === "ja") return ja_indoor(inputs)
	if (locale === "fr") return fr_indoor(inputs)
	if (locale === "es") return es_indoor(inputs)
	if (locale === "ru") return ru_indoor(inputs)
	if (locale === "zh") return zh_indoor(inputs)
	if (locale === "vi") return vi_indoor(inputs)
	return en_indoor(inputs)
});